import { LandingSection } from '@features/landing/shared/ui/components/LandingSection';
import { LandingSectionTitle } from '@features/landing/shared/ui/components/LandingSectionTitle';
import styles from './AdvantagesSection.module.css';
import { ReactNode } from 'react';

export type AdvantagesSectionProps = {
  title: ReactNode;
  leftItems: ReactNode;
  rightItems: ReactNode;
};

export function AdvantagesSection({
  title,
  leftItems,
  rightItems,
}: AdvantagesSectionProps) {
  return (
    <LandingSection>
      <div className={styles.root}>
        <LandingSectionTitle>{title}</LandingSectionTitle>

        <div className={styles.content}>
          <div className={styles.column}>{leftItems}</div>
          <div className={styles.column}>{rightItems}</div>
        </div>
      </div>
    </LandingSection>
  );
}
